const textHelper = {
  capitalizeFirstLetter: (txt: string) => {
    if (!txt || txt.length === 0) {
      return "";
    }
    return txt[0].toUpperCase() + txt.slice(1).toLowerCase();
  },
};

export default textHelper;
